import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContentLivePreviewModule } from '../../common/components/content-live-preview/content-live-preview.module';
import { LangMultiSelectComponent } from '../../common/components/lang-multi-select/lang-multi-select.component';
import { ProfileStorelogoModule } from '../../common/components/profile-storelogo/profile-storelogo.module';
import { PipeUtilModule } from '../pipes/pipe-util/pipe-util.module';
import { DataService } from './../../core/data/data-service';
import { AssetLibraryModule } from './../asset-library/asset-library.module';
import { CreateProfileComponent } from './create-profile.component';
import { FactTagsComponent } from './fact-tags/fact-tags.component';
import { ProfileInfoComponent } from './profile-info/profile-info.component';
import { ProfileStorelogoContainerComponent } from './profile-storelogo-container/profile-storelogo-container.component';
import { AttractLoopPopupModule } from '../../common/components/attract-loop-popup/attract-loop-popup.module';
import { ProfileAttractLoopComponent } from './profile-attract-loop/profile-attract-loop.component';
import { LivePreviewModule } from '../../common/components/live-preview/live-preview.module';
import { SettingsComponent } from './settings/settings.component';
import { InstallationPackageComponent } from './installation-package/installation-package.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { DateTimeZoneModule } from '../../../app/common/components/date-time-zone/date-time-zone.component/date-time-zone.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfirmDialogModule} from '../../../app/common/components/confirm-dialog/confirm-dailog.module';
import { DateTimePickerModule } from '../../common/components/datetimepicker/datetimepicker-popover/datetimepicker.module';

@NgModule({
  declarations: [
    CreateProfileComponent,
    ProfileInfoComponent,
    ProfileStorelogoContainerComponent,
    LangMultiSelectComponent,
    ProfileAttractLoopComponent,
    FactTagsComponent,
    SettingsComponent,
    InstallationPackageComponent,
    ChangePasswordComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    AssetLibraryModule, // TODO: Change this name  to a more common name
    FormsModule,
    PipeUtilModule,
    ProfileStorelogoModule,
    ReactiveFormsModule,
    ContentLivePreviewModule,
    AttractLoopPopupModule,
    LivePreviewModule,
    PipeUtilModule,
    DragDropModule,
    DateTimeZoneModule,
    NgSelectModule,
    ConfirmDialogModule,
    DateTimePickerModule
  ],
  providers: [
    DataService
  ],
  exports: [ProfileAttractLoopComponent, LangMultiSelectComponent]
})
export class CreateProfileModule { }
